import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function DesignTypeSummary() {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col items-start">
        <h2 className="font-bold text-md">Accepted File Types</h2>
        <p>JPG, PSD, AI, CDR, PDF, PNG, DST, EPS, SVG</p>
      </div>
      <div className="flex flex-col items-start gap-2">
        <h2 className="font-bold text-md">For Optimal Quality</h2>
        <ul className="text-left list-disc list-inside leading-relaxed">
          <li className="flex gap-2">
            <FontAwesomeIcon className="mt-1 text-[#2b99ee]" icon={faCheck}/>
            The file must be a valid image type. Upload from one of the file types above. Other file types accepted are: JPG, PSD, AI, CDR, PDF, PNG, DST, EPS, or SVG
          </li>
          <li className="flex gap-2">
            <FontAwesomeIcon className="mt-1 text-[#2b99ee]" icon={faCheck}/>
            300px resolution
          </li>
          <li className="flex gap-2">
            <FontAwesomeIcon className="mt-1 text-[#2b99ee]" icon={faCheck}/>
            Does not include anything that is not a part of the design
          </li>
          <li className="flex gap-2">
            <FontAwesomeIcon className="mt-1 text-[#2b99ee]" icon={faCheck}/>
            Full colour
          </li>
        </ul>      
      </div>
    </div>
  )
}